import { ContractMetadata } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_metadata_pb";
import { ContractStatus } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_pb";

export const ENTRY_PERISCOPE = "periscope";

export function generateContractMetadata({
  status,
  entry = ENTRY_PERISCOPE,
  experiment = "",
  featureFlags = [],
}: {
  status: ContractStatus;
  entry: string;
  experiment?: string;
  featureFlags?: string[];
}): ContractMetadata | undefined {
  if (status === ContractStatus.TRIALING) {
    return new ContractMetadata({
      details: {
        case: "trial",
        value: { entry, experiment, featureFlags },
      },
    });
  }

  return undefined;
}
